<template>
  <v-dialog v-if="warningDialog" v-model="warningDialog" max-width="500px" persistent>
    <v-card class="pa-4">
      <div>
        <v-card-title>
          <h2 class="title">Update Service Plan</h2>
        </v-card-title>
        <v-flex class="xs12 pa-4">
        <div class="dialog-warning-note mb-4">
            <v-layout class="align-center fill-height">
              <v-icon left color="error" class="mr-2 d-flex">new_releases</v-icon>
              <span class="d-flex" style="font-size: 13px!important; font-style: normal!important;">Today your organization has exceeded the maximum number of {{ maxJobs }} jobs per one field tech. Please update your service plan.</span>
            </v-layout>
        </div>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDialog">Ok</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service"
import { SET_PLAN_STATUS } from "@/store/mutations.type"
import {mapGetters} from "vuex"

export default {
  data () {
    return {
      warningDialog: false,
      maxJobs: 15,
      curentMaxPerTech: null,
      unsubscribe: null
    }
  },
  mounted () {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'CheckPlanStatus') {
          this.checkMaxJobsAndSetInterval(action.payload.data)
      }
    })
    this.checkMaxJobs()
    this.checkMaxJobsInterval()
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    checkMaxJobsInterval () {
      if(this.isSubscribed && this.subscriptionPackage === 'EntreMANURE') {
        let repeatAction = setInterval(() => {
          if(this.isSubscribed && this.subscriptionPackage === 'EntreMANURE') {
            this.checkMaxJobs()
          } else {
            clearInterval(repeatAction)
          }
        }, 600000)
      }
    },
    checkMaxJobs (justNow = false) {
      if(this.isSubscribed && this.subscriptionPackage === 'EntreMANURE') {
        ApiService.get('/dashboard/max_jobs')
          .then(response => {
            this.curentMaxPerTech = response.data.max_jobs
            if(this.curentMaxPerTech > this.maxJobs) {
              let a = moment(Date.now())
              let b = moment(Number(this.planStatus))
              if(a.diff(b, 'hours') > 23 || justNow) {
                this.warningDialog = true
                this.$store.commit(SET_PLAN_STATUS, Date.now())
              }
            }
          })
          .catch(error => {
              console.log(error)
          });
      }
    },
    checkMaxJobsAndSetInterval (justNow = false) {
      this.checkMaxJobs(justNow)
      this.checkMaxJobsInterval()
    },
    closeDialog () {
      this.warningDialog = false
      if(this.permissions.includes("subscription_details")) {
        this.$router.push('/settings/subscription_details')
      }
    }
  },
  computed: {
    ...mapGetters(["isSubscribed", "subscriptionPackage", "planStatus", "permissions"]),
  },
  watch: {
    subscriptionPackage: function(val) {
      this.checkMaxJobs()
      this.checkMaxJobsInterval()
    }
  }
}
</script>